// Quem usa a Central Lemit (consulta avulsa de CPF/CNPJ, API paga).
//
// O Comercial inteiro — Closer, BDR, Hunter e a gerência comercial — pela função ou pelo
// departamento (29/10/2026: o Hunter também). Fora dele, adm e alguns departamentos.
// A tela está em dois lugares: Gestão › Central Lemit e CRM › Central Lemit (/crm/lemit),
// porque Hunter e BDR têm papel `vendedor` e não entram no módulo Gestão.
import type { Profile } from '../../types';
import { ehDoComercial } from './departamentos.ts';

/** Departamentos com acesso à Central Lemit, além do Comercial inteiro. */
export const LEMIT_ALLOWED_DEPARTAMENTOS = [
  'Faturamento', 'Financeiro', 'Pós Venda', 'Tecnologia', 'Marketing',
];

type PerfilLemit = Pick<Profile, 'role' | 'departamento' | 'departamentos' | 'funcao_comercial'>;

export function hasLemitAccess(profile?: PerfilLemit | null): boolean {
  if (!profile) return false;
  if (profile.role === 'adm') return true;
  if (ehDoComercial(profile)) return true;
  const deps = (profile.departamentos && profile.departamentos.length > 0)
    ? profile.departamentos
    : (profile.departamento ? [profile.departamento] : []);
  return deps.some((d) => LEMIT_ALLOWED_DEPARTAMENTOS.includes(d));
}
